import ApiServiceV6 from '@/helpers/api.service.v6gbits';

const APIV6Gbits = new ApiServiceV6();

export const state = {
  errors: null
}

export const mutations = {
  SET_ERROR(state, errors){
    state.errors = errors;
  }
}

export const actions = {
    actionGbitsInvitation(context, params) {
    return new Promise((resolve, reject) => {
        APIV6Gbits.post(`/invitation/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }

          switch (params.action) {
            case "generate-invitation":
              break;
            case "send-invite-email":
              break;
            default:
              break;
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  }
}

export const getters = {}